import type { LoginProps } from './login.component';

/**
 * Maps HTML attribute names (kebab-case) to PromotedProductsComponent prop names (camelCase)
 */
export const LOGIN_ATTRIBUTE_MAP: Record<string, keyof LoginProps> = {
  'internal-title': 'internalTitle',
  'title-size': 'titleSize',
  description: 'description',
  'button-text': 'buttonText',
  alignment: 'alignment',
  'max-width': 'maxWidth',
  'button-full-width': 'buttonFullWidth',
  'text-color': 'textColor',
  'section-background-color': 'sectionBackgroundColor',
  'button-color': 'buttonColor',
  'button-border-color': 'buttonBorderColor',
  'button-text-color': 'buttonTextColor',
  'vertical-padding': 'verticalPadding',
  'horizontal-padding': 'horizontalPadding',
};

/**
 * Extracts attributes from an HTMLElement and converts them to CollectiblesComponent props
 */
export function extractLoginAttributes(element: HTMLElement): Partial<LoginProps> {
  const props: Partial<LoginProps> = {};

  for (const [attrName, propName] of Object.entries(LOGIN_ATTRIBUTE_MAP)) {
    const value = element.getAttribute(attrName);
    if (value !== null) {
      (props as any)[propName] = value;
    }
  }

  return props;
}
